// vendors
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";

// utils
import { SingleMenuProps } from "./utils";

// styles
import {
  ListItemTextStyled,
  PlaceholderTextStyled,
  SelectedLabelStyled,
} from "./date.styled";

type Option = {
  label: string;
  value: string;
};

const UISelect = (props: any) => {
  const { options, placeholder, value, defaultValue, onChange, disabled } = props;

  return (
    <Select
      displayEmpty
      IconComponent={KeyboardArrowDownIcon}
      value={value}
      defaultValue={defaultValue}
      input={<OutlinedInput sx={{ backgroundColor: "#F5F6F8" }} size="small" />}
      onChange={onChange}
      renderValue={(selected: any) => {
        if (selected && selected.length === 0) {
          return <PlaceholderTextStyled>{placeholder}</PlaceholderTextStyled>;
        }

        const match = options.filter((option: any) => option.value === selected)[0];
        return (
          <SelectedLabelStyled>
            {match?.label ? match?.label : ""}
          </SelectedLabelStyled>
        );
      }}
      fullWidth
      // @ts-ignore
      MenuProps={SingleMenuProps}
      disabled={disabled}
    >
      {options.map((option: Option) => (
        <MenuItem key={option.value} value={option.value}>
          <ListItemTextStyled primary={option.label} />
        </MenuItem>
      ))}
    </Select>
  );
};

export default UISelect;
